var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_104734)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3999 13.2736V10.52C5.3999 9.96774 5.84762 9.52002 6.3999 9.52002H17.6003C18.1526 9.52002 18.6003 9.96773 18.6003 10.52V13.2736C18.6003 16.0675 18.6003 17.4645 17.7411 18.3324C16.8819 19.2003 15.4991 19.2003 12.7334 19.2003H11.2668C8.50109 19.2003 7.11826 19.2003 6.25908 18.3324C5.3999 17.4645 5.3999 16.0675 5.3999 13.2736Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3999 9.52011L6.03453 8.16622C6.52673 7.11621 6.77282 6.5912 7.27165 6.2956C7.77047 6 8.41033 6 9.69003 6H14.3102C15.5899 6 16.2297 6 16.7286 6.2956C17.2274 6.5912 17.4735 7.11621 17.9656 8.16622L18.6003 9.52011",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6799 12.1602H13.32",
    stroke: "#FF4444",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_104734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPackage);
export default __webpack_public_path__ + "static/media/total_package.737fd4bd66ceecd842ca4709bc027bc6.svg";
export { ForwardRef as ReactComponent };